<template>
  <svg
    width="112"
    height="128"
    viewBox="0 0 112 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M101.393 67.5893L83.1907 85.7907H54.5973L38.9987 101.387V85.7907H15.6013V10.3987H101.393V67.5893ZM5.19866 -1.51857e-05L0 20.7987V114.385H23.4V127.387H36.3947L49.3973 114.385H70.192L111.787 72.796V-1.51857e-05H5.19866Z"
      fill="currentColor"
    />
    <path
      v-if="filled"
      d="M101.393 67.5893L83.1907 85.7907H54.5973L38.9987 101.387V85.7907H15.6013V10.3987H101.393V67.5893Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M44.1973 62.3942H54.5959V31.1929H44.1973V62.3942ZM72.7919 62.3942H83.1906V31.1929H72.7919V62.3942Z"
      fill="currentColor"
    />
  </svg>
</template>
<script setup lang="ts">
withDefaults(defineProps<{
  filled?: boolean,
}>(), {
  filled: false,
})
</script>
